const products = [
  {
    id: 1,
    title: "Samsung TV",
    price: 500000,
    quantity: 1,
  },
  {
    id: 2,
    title: "Pixel 4a",
    price: 250000,
    quantity: 1,
  },
  {
    id: 3,
    title: "PS 5",
    price: 300000,
    quantity: 1,
  },
  {
    id: 4,
    title: "MacBook Air",
    price: 800000,
    quantity: 1,
  },
  {
    id: 5,
    title: "Apple Watch",
    price: 95000,
    quantity: 1,
  },
  {
    id: 6,
    title: "Air Pods",
    price: 75000,
    quantity: 1,
  },
];

export default products;
